import { Product } from 'BrokerTsLib/src/enums'
import type { IMenuItem } from '../data/menu'
import { menuFleet, menuLeasing, menuProperty, menuTravel, menuVehicle } from '../data/menu'
import { useApp } from './useApp'

export const useMenu = (): IMenuItem[] => {
  const { lastProduct: product } = useApp()

  switch (product) {
    case Product.VehicleInsurance:
      return menuVehicle

    case Product.VehicleLeasingInsurance:
      return menuLeasing

    case Product.FleetInsurance:
      return menuFleet

    case Product.TravelInsurance:
      return menuTravel

    case Product.LiabilityInsurance:
    case Product.PropertyInsurance:
      return menuProperty
  }

  return []
}
